import styled from '@happymoneyinc/styled-components';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { TimelineContext } from './TimelineContext.js';
import { TimelineItem } from './TimelineItem.js';
import { TimelinePoint } from './TimelinePoint.js';
import { TimelineContent } from './TimelineContent.js';
import { TimelineTitle } from './TimelineTitle.js';
import { TimelineBody } from './TimelineBody.js';
import { TimelineTime } from './TimelineTime.js';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx } from 'react/jsx-runtime';

const TimelineComponent = props => {
  const {
    children,
    className,
    horizontal,
    ...rest
  } = props;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsx(TimelineContext.Provider, {
      value: {
        horizontal
      },
      children: /*#__PURE__*/jsx(StyledOl, {
        className: clsx({
          horizontal
        }, className),
        ...rest,
        children: children
      })
    })
  });
};
const StyledOl = styled.ol`
  list-style: none;

  &.horizontal {
    display: flex;
  }

  li:last-child .timeline-line {
    display: none;
  }
`;
TimelineComponent.defaultProps = {
  className: '',
  horizontal: false,
  children: null
};
TimelineComponent.propTypes = {
  className: PropTypes.string,
  horizontal: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
var Timeline = Object.assign(TimelineComponent, {
  Item: TimelineItem,
  Point: TimelinePoint,
  Content: TimelineContent,
  Time: TimelineTime,
  Title: TimelineTitle,
  Body: TimelineBody
});

export { Timeline as default };
//# sourceMappingURL=Timeline.js.map
